import "../styles/ParallaxTextSection.css";
import backgroundVideo from "../assets/video/video_tailand.mp4";

export default function ParallaxTextSection() {
  return (
    <section className="parallax-section">
      {/* VIDEO DE FONDO */}
      <video
        className="parallax-video"
        src={backgroundVideo}
        autoPlay
        muted
        loop
        playsInline
      />

      {/* OVERLAY */}
      <div className="parallax-overlay">
        <div className="parallax-content">
          <h4>García-Borreguero, estrategia, confianza y resultados</h4>

          <p>
            Nos especializamos en el análisis, la estructuración y la gestión de activos inmobiliarios, actuando bajo criterios de transparencia, rigor y orientación a resultados sostenibles en el largo plazo.
          </p>

          <p>
            Desarrollamos proyectos inmobiliarios que abarcan desde la identificación de oportunidades y su adecuación para la venta o el arrendamiento, hasta el asesoramiento legal en procesos hereditarios, la planificación fiscal y la coordinación de actuaciones como vaciado de inmuebles, pintura o reformas. 
          </p>

          <p>
            Nuestro objetivo es convertirnos en un apoyo fiable y profesional para nuestros clientes en cada decisión patrimonial.
          </p>

          <p>
            Hablemos del próximo paso:
            ¿Tienes preguntas o quieres iniciar un proyecto?
            Comparte tu consulta y un miembro de nuestro equipo te responderá para coordinar juntos el siguiente paso.

          </p>
        </div>
      </div>
    </section>
  );
}